//import tags
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


// import recources
import Cameraimage from '../../assets/image/camera.png'
import Rateimage from '../../assets/image/rating.png'
import Architecture from '../../assets/image/architecture.png'
import Lowimage from '../../assets/image/low.png'
import Social from '../../assets/image/social.png'

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";


function Services({locale}) {

    //get locale
    const { t } = useTranslation();

    return (
        <Container>
            <Row>
                <Col xxl={12}>
                    <section className="serviceSection">
                        
                        <div className="sectionHeader">
                            <div className="sectionHeaderLeft">
                                <h2>{t('our_services')}</h2>
                                <p>{t('our_services_text')}</p>
                            </div>
                        </div>
                        
                        <div className='servicesBoxOuter'>
                            
                            <div className='servicesBox'>
                                <Link to={`/${locale}/rate`}>
                                    <div className="singleHomeService">
                                        <div className="singleHomeServiceImage">
                                            <Image src={Rateimage} alt="Service" />
                                        </div>
                                        <h4>{t('measure_rate')}</h4>
                                    </div>
                                </Link>
                            </div>

                            <div className='servicesBox'>
                                <Link to={`/${locale}/photovideo`}>
                                    <div className="singleHomeService">
                                        <div className="singleHomeServiceImage">
                                            <Image src={Cameraimage} alt="Service" />
                                        </div>
                                        <h4>{t('photo_video')}</h4>
                                    </div>
                                </Link>
                            </div>

                            <div className='servicesBox'>
                                <Link to={`/${locale}/ads`}>
                                    <div className="singleHomeService">
                                        <div className="singleHomeServiceImage">
                                            <Image src={Social} alt="Service" />
                                        </div>
                                        <h4>რეკლამა სოც.მედიაში</h4>
                                    </div>
                                </Link>
                            </div>

                            <div className='servicesBox'>
                                <Link to={`/${locale}/architect`}>
                                    <div className="singleHomeService">
                                        <div className="singleHomeServiceImage">
                                            <Image src={Architecture} alt="Service" />
                                        </div>
                                        <h4>{t('architecture_design2')}</h4>
                                    </div>
                                </Link>
                            </div>

                            <div className='servicesBox'>
                                <Link to={`/${locale}/consulting`}>
                                    <div className="singleHomeService">
                                        <div className="singleHomeServiceImage">
                                            <Image src={Lowimage} alt="Service" />
                                        </div>
                                        <h4>{t('legal_service')}</h4>
                                    </div>
                                </Link>
                            </div>

                        </div>


                    </section>
                </Col>
            </Row>
        </Container>
    )

}

export default Services;